const USERS = "users";

export const usersKeys = {
	deleteMe: [USERS, "delete-me"] as const,
	list: [USERS, "list"] as const,
	me: [USERS, "me"] as const,
	projects: (id: string) => [USERS, id, "projects"] as const,
	updateMe: [USERS, "update-me"] as const,
	updateEmail: [USERS, "update-email"] as const,
	updatePassword: [USERS, "update-password"] as const,
	updateRole: [USERS, "update-role"] as const,
};
